import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      /*
       * Come back to the tab and it is up to date.
       *
       * This used to be off, on the reasoning that a dashboard does not need
       * to chatter. But a teacher who leaves the classroom machine open all
       * morning and comes back to it should not be reading yesterday — and
       * the thirty-second staleness below already stops a click-in-and-out
       * from firing a request every time.
       */
      refetchOnWindowFocus: true,
      staleTime: 30_000,
      retry: 1,
    },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
